import { GoatSurprised, useIntl } from '@capsicum/common';
import { Button, GenericDrawer } from '@capsicum/common-web';
import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

export type EarnRewardPointsProps = PropsWithChildren<{
	onClick?: () => void;
	testID: string;
}>;
export const EarnRewardPoints = ({ onClick, testID }: EarnRewardPointsProps) => {
	const { $t } = useIntl();

	return (
		<GenericDrawer image={GoatSurprised} imageSize={{ height: 220, width: 220 }} testID={testID}>
			<S.Title>{$t('rewards.earnRewardPoints.title')}</S.Title>
			<S.Subtitle>{$t('rewards.earnRewardPoints.subtitle')}</S.Subtitle>
			<S.Description>{$t('rewards.earnRewardPoints.description')}</S.Description>
			<Button
				fullWidth
				testID={`${testID}-button`}
				text={$t('rewards.earnRewardPoints.buyChiliz')}
				onClick={() => {
					onClick?.();
				}}
			/>
		</GenericDrawer>
	);
};

namespace S {
	export const Title = styled.div`
		text-align: center;
		color: ${({ theme }) => theme.colors.text.main.enabled};
		${({ theme }) => theme.fonts.headings.title6};
		padding: ${({ theme }) => `0 ${theme.spacings.xsmall}`};
		margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
		margin-top: ${({ theme }) => theme.spacings.large};
	`;

	export const Subtitle = styled.div`
		text-align: center;
		color: ${({ theme }) => theme.colors.text.main.enabled};
		${({ theme }) => theme.fonts.text.text3};
		padding: ${({ theme }) => `0 ${theme.spacings.xsmall}`};
	`;

	export const Description = styled.div`
		text-align: center;
		color: ${({ theme }) => theme.colors.text.main.enabled};
		${({ theme }) => theme.fonts.text.text3};
		padding: ${({ theme }) => `${theme.spacings.large} ${theme.spacings.xsmall}`};
	`;
}
